import AdminPageShell, { type AdminPageShellProps } from '../admin/AdminPageShell';
import { FORMATEUR_HERO_BACKGROUND } from '../admin/AdminPageHero';

export type { AdminPageHeroSideCard } from '../admin/AdminPageShell';

export type FormateurPageShellProps = Omit<AdminPageShellProps, 'backgroundImage'>;

/**
 * Enveloppe des pages formateur : même hero que l’admin / apprenant, fond `hero-banner-3.jpg`.
 */
export default function FormateurPageShell(props: FormateurPageShellProps) {
  return <AdminPageShell {...props} backgroundImage={FORMATEUR_HERO_BACKGROUND} />;
}
